export const EVENT_URI = 'cwi2026';
export const COUNTDOWN_EVENT_DATE = '2026-06-08T14:00:00+00:00';

export const INTERNAL_IDS = {
  terms: '120',
  firstName: '12',
  lastName: '11',
  usedNameIfDifferent: '110', // nuevo
  company: '133',
  jobTitle: '135',
  headline: '13',
  role: '14', // nuevo, antes era telephone
  linkedInProfile: '161', // nuevo
  customTelephone: '134',
  email: '16',
  assistantEmail: '106',
  nationality: '18',
  passportNumber: '113',
  birthdate: '136',
  passportExpiryDate: '114',
  downloadInvitationLetter: '193',
  emergencyContactName: '199',
  emergencyContactPhone: '1991',
  photo: '194',
  accompanyingGuest: '1951',
  accGuestFirstName: '195112',
  accGuestLastName: '19111',
  guestJoiningCWICeremony: '1955',
  guestEmailAddress: '19551',
  guestSharingTransfers: '1953',
  guestSameRoom: '1952',
  twinOrDoubleBed: '19521',
  commentAboutProfile: '1954',
  // priority: '196', // nuevo
  // subCategory: '197', // nuevo
  // tye: '198', // nuevo
  hotelName: '121',
  checkIn: '117',
  checkOut: '118',
  // comment: '24', // nuevo
  typeOfBedroom: '26',
  // commentByOrgaTeam: '25', // nuevo
  typeOfGuests: '119',
  zones: '126',
  zonesDetails: '122',
  communities: '123',
  vip: '124',
  workshopGroup: '125',
  billing: '27',
  transfer: '3',
  arrivalDate: '108',
  needArrivalAirportTransfer: '115',
  arrivalFlightNumber: '100',
  arrivalTime: '101',
  arrivalFrom: '102',
  arrivalTo: '1021',
  arrivalComments: '324',
  departureDate: '107',
  needDepartureAirportTransfer: '116',
  departureFlightNumber: '103',
  departureTime: '104',
  departureFrom: '1051',
  departureTo: '105',
  departureComments: '344',
  departurePickUpTime: '111',
  dietaryRequirements: '112',
  specifyYourSpecialDiet: '42',
  medicalFoodAllergies: '411',
  sundayDinner: '51',
  yourActivityTitle: '7',
  myHeight: '61',
  needHelpPhone: 'needHelpPhone',
  seatingArea: '200',
  seatNumber: '201',
  // Wallet (EventWallet)
  flightTicket: '36',
  hotelReservation: '27', // Same as billing
  expoEntranceMay21: '74',
  expoEntranceMay22: '75',
  // Profile (visaFields)
  // Accompanying Guest
  // Other
};

// TODO: Actualizar IDs para cwi2026
export const WORKSHOP_CATEGORIES = {
  mandatory: '9751',
  optional: '9752',
  plenieres: '8811',
  workshops: '8812',
  soirees: '8813',
  activites: '9888',
  umbrella: '9887',
  hidden: '',
};

export const UMBRELLA_ACTIVITY_ID = '395375';

export const UMBRELLA_HIDDEN_WORKSHOP_ID = '522681';
export const UMBRELLA_HIDDEN_FOR_ATTENDEE_IDS = new Set([
  '49262568', '49262570', '50536524', '49287043', '50329020', '49287071',
  '49282062', '49282986', '49282987', '50328695', '49262174', '49262204',
  '51269371', '49283149', '49283150', '49262179', '49262194', '49262212',
  '49262200', '49262195', '49284614', '49287817', '49262565', '49262566',
  '49772300', '50939802', '51217334', '50939943', '50939959', '51216882',
  '51293351', '51327499', '52092103',
]);
export const VIRTUAL_ATTENDEE_TYPE_ID = '179929';
export const ACTIVE_MODULES = ['Workshops', 'Attendees', 'Custom', 'AttendeeProfile', 'Sponsors', 'Surveys', 'Speakers', 'SocialWall', 'AttendeeLeads', 'QASessions', 'Quizzes'];

const INPUT_TYPES = {
  TEXT_FIELD: 1,
  TEXT_AREA: 2,
  CHECKBOX: 3,
  SELECT: 4,
  RADIO: 5,
  IMAGE: 6,
  LABEL: 7,
  CITY: 8,
  FILE: 9,
  DATE_TIME: 10,
  RATING: 11,
  TERMS_CONDITIONS: 20,
  DOWNLOAD_BUTTON: 500,
};

export default INPUT_TYPES;

export const ATTENDANCE_MODE = {
  PHYSICAL: 'offline',
  VIRTUAL: 'online',
  HYBRID: 'mixed',
};

export const STAGE_TAB_NAMES = {
  TIMELINE: 0,
  CHAT: 1,
};

export const MEETING_REQUEST_STATUSES = {
  REQUESTED: 'requested',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
};

export const MEETING_REQUEST_TYPES = {
  RECEIVED: 'received',
  SENT: 'sent',
};

// TODO: Actualizar IDs para cwi2026
export const ACTVITIES_WITH_REPLAY = {
  395351: 'introduction',
  395352: 'FY25Keytrends',
  395354: 'HumanResources',
  395355: 'OperationsAndMetiers',
  395356: 'LEcoledesArtsJoailliers',
  420585: 'IntroductionMarketingCommunicationPatrimony',
  420586: 'MarketingHighJewelry',
  420587: 'MarketingTimepieces',
  420588: 'MarketingJewelry',
  420589: 'Communication',
  420591: 'Patrimony',
  420592: 'Retail',
  409857: 'Retail',
  420590: 'DanceReflections',
  395393: 'Conclusion',
};

export const REPLAYS = {
  introduction: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/Introduction/',
    banner: 'https://cdn.eventtia.com/event_files/216774/medium/introduction.jpg?1753979220',
    name: 'Introduction',
    linkedWorkshops: ['395351'],
  },
  FY25Keytrends:
  {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/FY25Keytrends/',
    banner: 'https://cdn.eventtia.com/event_files/216775/medium/key-trends.jpg?1753979238',
    name: 'Key Trends',
    linkedWorkshops: ['395352'],
  },
  HumanResources: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/HumanResources/',
    banner: 'https://cdn.eventtia.com/event_files/216777/medium/human-resources.jpg?1753979282',
    name: 'Human Resources',
    linkedWorkshops: ['395354'],
  },
  OperationsAndMetiers: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/OperationsAndMetiers/',
    banner: 'https://cdn.eventtia.com/event_files/216776/medium/operations-me-tiers.jpg?1753979264',
    name: 'Operations & Métiers',
    linkedWorkshops: ['395355'],
  },
  LEcoledesArtsJoailliers: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/LEcoledesArtsJoailliers/',
    banner: 'https://cdn.eventtia.com/event_files/216786/medium/l-e-cole.jpg?1753979446',
    name: 'L’École',
    linkedWorkshops: ['395356'],
  },
  IntroductionMarketingCommunicationPatrimony: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/IntroductionMarketingCommunicationPatrimony/',
    banner: 'https://cdn.eventtia.com/event_files/216778/medium/marketing-communication-patrimony.jpg?1753979313',
    name: 'Marketing, Communication & Patrimony',
    linkedWorkshops: ['420585'],
  },
  MarketingHighJewelry: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/MarketingJewelry/',
    banner: 'https://cdn.eventtia.com/event_files/216779/medium/high-jewelry.jpg?1753979342',
    name: 'High Jewelry',
    linkedWorkshops: ['420586'],
    // linkedWorkshops: ['395365', '395380', '395370', '395384', '395389'],
  },
  MarketingTimepieces: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/MarketingTimepieces/',
    banner: 'https://cdn.eventtia.com/event_files/216781/medium/timepieces.jpg?1753979377',
    name: 'Timepieces',
    linkedWorkshops: ['420587'],
    // linkedWorkshops: ['395366', '395371', '395381', '395385', '395390'],
  },
  MarketingJewelry: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/MarketingHighJewelry/',
    banner: 'https://cdn.eventtia.com/event_files/216780/medium/jewelry.jpg?1753979361',
    name: 'Jewelry',
    linkedWorkshops: ['420588'],
    // linkedWorkshops: ['395364', '395367', '395369', '395378', '395379'],
  },
  Communication: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/Communication/',
    banner: 'https://cdn.eventtia.com/event_files/216782/medium/communication.jpg?1753979391',
    name: 'Communication',
    linkedWorkshops: ['420589'],
    // linkedWorkshops: ['395368', '395372', '395392', '395386', '395382'],
  },
  Patrimony: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/Patrimony/',
    banner: 'https://cdn.eventtia.com/event_files/216784/medium/patrimony.jpg?1753979407',
    name: 'Patrimony',
    linkedWorkshops: ['420591'],
  },
  Retail: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/Retail/',
    banner: 'https://cdn.eventtia.com/event_files/216785/medium/retail.jpg?1753979426',
    name: 'Retail',
    linkedWorkshops: ['420592', '409857'],
    // linkedWorkshops: ['395377', '395373', '395383', '395387', '395391'],
  },
  DanceReflections: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/14',
    banner: 'https://cdn.eventtia.com/event_files/219128/medium/dance-reflections.png?1757611878',
    name: 'Dance Reflections',
    linkedWorkshops: ['420590'],
  },
  Conclusion: {
    iframeSrc: 'https://armcast.vo-live.fr/VCA2025/replays/Conclusion/',
    banner: 'https://cdn.eventtia.com/event_files/216787/medium/conclusion.jpg?1753979462',
    name: 'Conclusion',
    linkedWorkshops: ['395393'],
  },
};
